import { render } from "./SubLayout.vue?vue&type=template&id=ef6f62b6"
const script = {}

import exportComponent from "D:\\UniParking\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__